import React from 'react'
import { useTranslation } from 'react-i18next'

import ThermalPrint, { ThermalPrintButton, useThermalPrint } from 'pages/parts/ThermalPrint'

import { formatMoney, formatDate } from 'helpers/helpers'

function Index({ showRightBar, setShowRightBar, data }) {
	const { t } = useTranslation()
	const { printRef, handlePrint } = useThermalPrint()

	return (
		<>
			<div className="right-sidebar-background" onClick={() => setShowRightBar(!showRightBar)}></div>
			<div className="right-sidebar p-2">
				<div className="position-relative">
					<div className="px-2"
						style={{
							position: 'absolute',
							top: '0',
							right: '0',
							zIndex: 2,
						}}>
						<ThermalPrintButton onClick={handlePrint} />
					</div>

					<h4 className="fw-600 pe-5">{t('document_from')} {formatDate(data.created_at, 'dd.MM.yy HH:mm')}</h4>
					<div className="flex-column preview-info">
						<div className="d-flex">
							<div className="fw-600 me-3">{t('pos')}:</div>
							<div>{data.pos_name}</div>
						</div>
						<div className="d-flex">
							<div className="fw-600 me-3">{t('from_warehouse')}:</div>
							<div>{data.wms_from_name}</div>
						</div>
						<div className="d-flex">
							<div className="fw-600 me-3">{t('to_warehouse')}:</div>
							<div>{data.wms_to_name}</div>
						</div>
						<div className="d-flex">
							<div className="fw-600 me-3">{t('note')}:</div>
							<div>{data.note}</div>
						</div>
					</div>

					<div className="table-responsive">
						<table className="table table-bordered">
							<thead>
								<tr>
									<th style={{ 'minWidth': '33px' }} className="text-center">#</th>
									<th style={{ 'width': '40%' }}>{t('name2')}</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis text-end">{t('quantity')}</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis">{t('unit')}</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis text-end">{t('cost_price')}</th>
									<th style={{ 'width': '15%' }} className="td-ellipsis text-end">{t('amount')}</th>
								</tr>
							</thead>
							<tbody>
								{data?.items?.map((item, index) => (
									<tr key={index}>
										<td className="text-center">{index + 1}</td>
										<td>{item.element_name}</td>
										<td className="text-end">{formatMoney(item.quantity, 2)}</td>
										<td className="text-start">{item.unit_name}</td>
										<td className="text-end text-nowrap">{formatMoney(item.cost_price)}</td>
										<td className="text-end text-nowrap">{formatMoney(item.total_price)}</td>
									</tr>
								))}
								<tr>
									<td></td>
									<td><b>{t('total')}</b></td>
									<td></td>
									<td></td>
									<td></td>
									<td className="text-end text-nowrap"><b>{formatMoney(data.total_amount)}</b></td>
								</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>

			<ThermalPrint
				printRef={printRef}
				title={`${t('document_from')} ${formatDate(data.created_at, 'dd.MM.yy HH:mm')}`}
				info={[
					{ label: t('pos'), value: data.pos_name },
					{ label: t('from_warehouse'), value: data.wms_from_name },
					{ label: t('to_warehouse'), value: data.wms_to_name },
					{ label: t('note'), value: data.note },
				]}
				columns={[
					{ label: t('name2'), width: '42%', numbered: true, render: (item) => item.element_name },
					{ label: t('quantity'), width: '16%', align: 'end', render: (item) => formatMoney(item.quantity, 2) },
					{ label: t('cost_price'), width: '20%', align: 'end', render: (item) => formatMoney(item.cost_price) },
					{ label: t('amount'), width: '22%', align: 'end', render: (item) => formatMoney(item.total_price) },
				]}
				rows={data?.items || []}
				total={[t('total'), '', '', formatMoney(data.total_amount)]}
			/>
		</>
	)
}

export default Index
